import type { Nullable } from "../types";

/**
 * This function is used to guard a number input and return a default value of 0 if the input is null, undefined, or not a number.
 * @param input
 * @returns
 */
export function guardNumber(input: Nullable<number> | unknown): number {
	if (Number.isNaN(input)) return 0;
	if (typeof input === "boolean") return input ? 1 : 0;
	if (typeof input === "string") {
		const parsed = Number.parseFloat(input);
		return Number.isNaN(parsed) ? 0 : parsed;
	}
	if (typeof input === "object") return 0;
	if (typeof input === "number") return input;
	return 0;
}
